import { useTurnStore } from "@/features/tutor/store/useTurnStore";

export const isFromOtherTurn = (event: Event): boolean => {
  const turnId = (event as CustomEvent<{ turn_id?: unknown } | null>).detail
    ?.turn_id;
  const currentTurnId = useTurnStore.getState().getTurnId();
  return (
    typeof turnId === "string" &&
    turnId.length > 0 &&
    Boolean(currentTurnId) &&
    turnId !== currentTurnId
  );
};
